module.exports = __webpack_public_path__ + "img/thumbnail02.f42552ca.jpg";